var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-list"},_vm._l((_vm.jobDataList),function(item){return _c('PositionItem',{key:item.id,attrs:{"job-item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }